export default "__VITE_ASSET__VwC7Hf_v__"